import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GridService } from 'src/app/shared/services/grid.service';
import { LangService } from 'src/app/core/services/lang.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-report-list',
  templateUrl: './../../../templates/forms/modals/report-list.component.html'
})
export class HrReportListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;
  @Input()
  optionalParam: any;
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "ReportListGridId"

  reportList: any[] = [];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.submenuId, field: 'SUBMENU_NAME_USER', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.reportsName, field: 'SUBMENU_ID', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.load('FG_SA_COMM_REPORT_LIST', JSON.parse(JSON.stringify({ P_SUBMENU_ID: this.optionalParam }))).subscribe(results => {
      this.reportList = results.body; 
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }

}
